/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Breadcrumb_HomeInputs */

const en_breadcrumb_home = /** @type {(inputs: Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HOME`)
};

const pt_breadcrumb_home = /** @type {(inputs: Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`INÍCIO`)
};

const es_breadcrumb_home = /** @type {(inputs: Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`INICIO`)
};

/**
* | output |
* | --- |
* | "HOME" |
*
* @param {Breadcrumb_HomeInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const breadcrumb_home = /** @type {((inputs?: Breadcrumb_HomeInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Breadcrumb_HomeInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_breadcrumb_home(inputs)
	if (locale === "es") return es_breadcrumb_home(inputs)
	return en_breadcrumb_home(inputs)
});